import { Box, Button, FormHelperText, Stack } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import useFetchJson from "../../../data/useFetchJson"
import { AlertDialog, LoadingBox, hikoAlert, useNavigateWithParams } from "@northpowerdev/np-react-utils"
import { MahiContext, mahiNameFromMahiContext } from "../../state/MahiContext"
import { RemedialDetails } from "./DlspRemedialDetails"
import DlspRemedialAssessmentForm from "./DlspRemedialAssessmentForm"

export function DlspRemedialAssessmentPanel({ taskDetails, assignee, onEdited, userName, isQARole, fspStatusNoEdit }) {
    const [isEditing, setIsEditing] = useState(false)
    const [showAlert, setShowAlert] = useState(false)
    const [qaOwner, setQAOwner] = useState('')
    const mahiContext = useContext(MahiContext)

    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    const claimDesktopQAPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/claim-desktop-qa-ownership'
    const {
        isLoading: isClaimingDesktopQA,
        load: claimDesktopQA } = useFetchJson(claimDesktopQAPath, { method: 'POST' })
        
    const caseInSalesforcePath = '/bff/decommissioned-lines-service/api/decommissioned-lines/create-case'
    const {
        isLoading: isSendingToSalesforce,
        load: loadSendToSalesforce } = useFetchJson(caseInSalesforcePath, { method: 'POST' })


    useEffect(() => {
        if (!taskDetails) {
            return
        }
        setQAOwner(taskDetails.decomICP?.desktopQAOwner || '')
    }, [taskDetails])
    
    const remedialButtonLabel = taskDetails?.decomICP?.remedial
        ? "Edit FSP instructions" 
        : "Create FSP instructions"

    const handleDesktopQAFormEdited = () => {
        setIsEditing(false)
        onEdited() // tell parent the assessment form has been edited (even though it might just have been closed)
    }

    const handleDesktopQAEditStart = async () => {
        const fetchParams = { params: { icp: taskDetails.decomICP.icp } }
        const claimedOK = await claimDesktopQA(fetchParams)
        if (claimedOK !== undefined) {
            const mahiName = mahiNameFromMahiContext(mahiContext)
            setIsEditing(true)
            setQAOwner(mahiName)
        }
    }
    const sendToSalesforce = async (value) => {
        console.log('good to go', value)
        const fetchParams = { params: { icpNo: taskDetails?.decomICP?.icp } }
        const claimedOK = await loadSendToSalesforce(fetchParams)
        if(claimedOK.caseNumber){
            console.log("claimedOK: ", claimedOK)
            setShowAlert(false)
            hikoAlert('Success!', `Your request has been received by Northpower. Your new case number is ${claimedOK.caseNumber}.`, 'success')
            let navigateParams = {icp_number: taskDetails?.decomICP?.icp}
            navigateToTaskDetails(navigateParams)
        }
    }

    const isQAOtherOwner = qaOwner && qaOwner !== userName
    const qaButtonHelperText = qaOwner ? `Owned by ${qaOwner}` : ''
    return (
        <Box>
            {
                isEditing
                    ?
                    <DlspRemedialAssessmentForm
                        remedialDetails={taskDetails?.decomICP?.remedial}
                        qaComments={taskDetails?.decomICP?.fieldQA?.fieldQAComments || taskDetails?.decomICP?.desktopQA?.desktopQAComments}
                        statusHistory={taskDetails?.statusHistory}
                        icpNumber={taskDetails?.decomICP?.icp}
                        assignee={assignee}
                        onClose={handleDesktopQAFormEdited}
                    />
                    :
                    <>
                        <LoadingBox loading={isSendingToSalesforce} message="Checking ownership...">
                            <RemedialDetails
                                remedial={taskDetails?.decomICP?.remedial}
                                fspStatusNoEdit={false}
                                remedialDate={taskDetails?.decomICP?.remedialDate}
                                remedialBy={taskDetails?.decomICP?.remedialBy}
                            />

                            {
                                !fspStatusNoEdit &&
                                <LoadingBox loading={isClaimingDesktopQA} message="Checking ownership...">
                                    <Stack direction="row" justifyContent="space-between">
                                        <Button variant="contained" disabled={isQAOtherOwner || fspStatusNoEdit} sx={{ my: 1 }} color="primary" onClick={handleDesktopQAEditStart} >
                                            {remedialButtonLabel}
                                        </Button>
                                        {
                                            isQARole
                                            &&
                                            <Button variant="text" sx={{ my: 1 }} color="secondary" disabled={fspStatusNoEdit} onClick={handleDesktopQAEditStart} >
                                                Become QA Owner
                                            </Button>
                                        }
                                    </Stack>
                                    {
                                        qaButtonHelperText
                                        &&
                                        <FormHelperText>{qaButtonHelperText}</FormHelperText>
                                    }
                                </LoadingBox>
                            }
                            {
                                taskDetails?.decomICP?.remedialBy &&
                                <>                                 
                                    <Button variant="contained" disabled={isQAOtherOwner || fspStatusNoEdit} sx={{ my: 1 }} color="primary" onClick={() => setShowAlert(true)} >
                                        {'Send to Salesforce'}
                                    </Button>
                                    <AlertDialog
                                        open={showAlert}
                                        title={"Are you sure you want to send this to Salesforce?"}
                                        content={"This will take the completed task and create a case in Salesforce for contracting to resolve. Once this is done, the task will become uneditable."}
                                        leftLabel={"No"}
                                        onLeftClick={() => setShowAlert(false)}
                                        rightLabel={"Yes"}
                                        onRightClick={() => sendToSalesforce(true)}
                                        onClose={() => setShowAlert(false)}
                                    />
                                </>
                            }
                        </LoadingBox>
                    </>
            }

        </Box>
    )
}
